import { ReactNode } from 'react';

interface SettingsWrapperProps {
    title: string;
    subtitle: string;
    children: ReactNode;
}

const SettingsWrapper = ({ title, subtitle, children }: SettingsWrapperProps) => (
    <div className="min-h-full flex items-start justify-center px-4 py-8 bg-gray-50">
        <div className="w-full max-w-2xl">
            <div className="mb-6">
                <h1 className="text-xl font-bold text-gray-900">{title}</h1>
                <p className="text-sm text-gray-400 mt-0.5">{subtitle}</p>
            </div>
            {children}
        </div>
    </div>
);

export default SettingsWrapper;